import { Input, Form } from 'antd'

const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 12,
  },
}


const InputOma = ({
  name, label, disabled,
}) => {
  console.log()
  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      name={name}
    >
      <Input disabled={disabled} />
    </Form.Item>
  )
}

export default InputOma
